import { useEffect } from 'react';

export function useTooltipLeaveGuard({ open, triggerRef, onClose }) {
  useEffect(() => {
    if (!open) return;
    const onMove = (e) => {
      const el = triggerRef.current;
      if (!el) return;
      const rect = el.getBoundingClientRect();
      if (
        e.clientX < rect.left ||
        e.clientX > rect.right ||
        e.clientY < rect.top ||
        e.clientY > rect.bottom
      ) {
        onClose();
      }
    };
    document.addEventListener('pointermove', onMove);
    return () => document.removeEventListener('pointermove', onMove);
  }, [open, triggerRef, onClose]);
}
